import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { httpClient } from '@/api/http-client'
import { Borrower } from '@/types'

type ListBorrowersParams = {
  companyKey: string
  params?: { tax_id?: string; name?: string }
}

export const listBorrowers = async ({
  companyKey,
  params,
}: ListBorrowersParams) => {
  const response = await httpClient('accounting-dealer').get<Borrower[]>(
    `/v3/company/${companyKey}/borrowers`,
    { params: { ...params } },
  )
  return response.data
}

export const useListBorrowers = (
  params: ListBorrowersParams,
  options?: Partial<UseQueryOptions<Borrower[], Error, Borrower[]>>,
) => {
  return useQuery({
    queryKey: ['borrowers', params],
    queryFn: () => listBorrowers(params),
    ...options,
  })
}
